<template>
    <div :class="formGroupClass">
        <label class="control-label col-md-3">{{ title }}</label>
        <div class="col-md-9">
            <input :id="id" type="file" :disabled="uploading" :accept="accept" @change="uploadFile"/>
            <span v-if="errorText" class="help-block">
                <p> {{errorText}} </p>
            </span>
        </div>
    </div>
</template>

<script>
import toastr from '../../js/toastr'

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    errors: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
  },
  data: function () {
    return {
      file: null,
      uploaded: false,
      uploading: false,
      id : `form_${this.name}`,
      errorText: false,
      formGroupClass: 'form-group'
    }
  },
  watch : {
    errors: function(value) {
      if (value[this.name]) {
        this.errorText = Object.values(value[this.name]).join()
        this.formGroupClass += ' has-error'
      }
    },
    uploading: function (value) {
      this.$parent.$emit('fileUploading', value)
    },
    value: function (value) {
      this.file = value
    },
  },
  methods: {
    uploadFile: function (e) {
      this.uploading = true
      var files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        this.$emit('input', null)
        toastr.error(Translator.trans('form.errors.invalid_file'))
        return
      }

      var formData = new FormData()
      formData.append('file', files[0])

      var url = Routing.generate('api_post_temp_upload')

      this.$http.post(url, formData)
        .then(response => {
          this.$emit('input', response.data)
          this.file = response.data
          this.uploaded = true
          this.uploading = false
        })
    },
  },
}
</script>
